<template>
    <div>
        <div v-if="screen > 767" :class="bannerContainer">
            <div :class='right'>
                <v-img contain :src="Image1" class="image1" />
            </div>
        </div>

        <div v-else>
            <v-img contain :src="Image1Mobile" class="image1Mobile" />
            <div style="display: flex;justify-content: center;align-items: center;margin-left: -8%;">
            </div>
            <div style="margin: auto; display: flex;justify-content: center;margin-top: 10%;">
                <v-btn :class="btnQuote" @click="goQuote">Cotizar y contratar</v-btn>
            </div>
        </div>

        <div :class="priceTagTitle">
            <label>Conoce los precios por tipo de vehículo</label>
        </div>



        <div v-if="screen > 767" :class="priceTagsContainer">
            <div :class="priceTag">
                <div :class="priceTagContainerAuto">
                    <v-img contain :src="Auto" max-width="35" style="margin-top: 8%;" :class="imagesAuto" />
                    <label :class="tituloAuto">
                        {{ planData.soap.car.name }}
                    </label>
                </div>
                <hr class="tagSpace">
                <div class="price">
                    <label>
                        {{ formatPrice(planData.soap.car.price) }}
                    </label>
                </div>
            </div>
            <div :class="priceTag">
                <div :class="priceTagContainer">
                    <v-img contain :src="Camioneta" max-width="35" :class="imagesCamioneta" />
                    <label :class="tituloLargo">
                        {{ planData.soap.camioneta.name }}
                    </label>
                </div>
                <hr class="tagSpace">
                <div class="price">
                    <label>
                        {{ formatPrice(planData.soap.camioneta.price) }}
                    </label>
                </div>
            </div>
            <div :class="priceTag">
                <div :class="priceTagContainerMoto">
                    <v-img contain :src="Moto" max-width="25" :class="images2" />
                    <label class="tituloLargoMoto">
                        {{ planData.soap.moto.name }}
                    </label>
                </div>
                <hr class="tagSpace">
                <div class="price">
                    <label>
                        {{ formatPrice(planData.soap.moto.price) }}
                    </label>
                </div>
            </div>
            <div :class="priceTag">
                <div :class="priceTagContainer">
                    <v-img contain :src="Carro" max-width="35" class="imagesCarro" />
                    <label :class="tituloLargo">
                        {{ planData.soap.arrastre.name }}
                    </label>
                </div>
                <hr class="tagSpace">
                <div class="price">
                    <label>
                        {{ formatPrice(planData.soap.arrastre.price) }}
                    </label>
                </div>
            </div>
            <div :class="priceTag">
                <div class="priceTagContainerBus">
                    <v-img contain :src="Minibus" max-width="25" class="imagesBus" />
                    <label class="tituloLargoBus">
                        {{ planData.soap.bus.name }}
                    </label>
                </div>
                <hr class="tagSpace">
                <div class="price">
                    <label>
                        {{ formatPrice(planData.soap.bus.price) }}
                    </label>
                </div>
            </div>
        </div>

        <div v-else class="priceTagsContainerMobile">
            <div style="display: flex;gap: 5%;margin: auto;justify-content: center;">
                <div class="priceTagMobile">
                    <div style="display: flex;justify-content: center;margin-top: 2%;">
                        <v-img contain :src="Auto" max-width="28" class="images" />
                        <label class="tituloLargoMobile">
                            {{ planData.soap.car.name }}
                        </label>
                    </div>
                    <hr class="tagSpaceMobile">
                    <div class="priceMobile">
                        <label>
                            {{ formatPrice(planData.soap.car.price) }}
                        </label>
                    </div>
                </div>
                <div class="priceTagMobile">
                    <div style="display: flex;justify-content: center;margin-top: 2%;">
                        <v-img contain :src="Camioneta" max-width="30" class="images" />
                        <label class="tituloCamionetaMobile">
                            {{ planData.soap.camioneta.name }}
                        </label>
                    </div>
                    <hr class="tagSpaceMobile">
                    <div class="priceMobile">
                        <label>
                            {{ formatPrice(planData.soap.camioneta.price) }}
                        </label>
                    </div>
                </div>
            </div>
            <br>
            <div style="display: flex;gap: 5%;margin: auto;justify-content: center;">
                <div class="priceTagMobile">
                    <div class="motoContainer">
                        <v-img contain :src="Moto" max-width="25" class="images" />
                        <label class="tituloLargoMobile">
                            {{ planData.soap.moto.name }}
                        </label>
                    </div>
                    <hr class="tagSpaceMobile">
                    <div class="priceMobile">
                        <label>
                            {{ formatPrice(planData.soap.moto.price) }}
                        </label>
                    </div>
                </div>

                <div class="priceTagMobile">
                    <div style="display: flex;justify-content: center;margin-top: 2%;">
                        <v-img contain :src="Carro" max-width="30" class="images" />
                        <label class="tituloLargoMobile">
                            {{ planData.soap.arrastre.name }}
                        </label>
                    </div>
                    <hr class="tagSpaceMobile">
                    <div class="priceMobile">
                        <label>
                            {{ formatPrice(planData.soap.arrastre.price) }}
                        </label>
                    </div>
                </div>
            </div>
            <br>
            <div style="display: flex;gap: 5%;margin: auto;justify-content: center;">
                <div class="priceTagMobile">
                    <div style="display: flex;justify-content: center;margin-top: 8%;margin-bottom: 6%;">
                        <v-img contain :src="Minibus" max-width="25" class="images" />
                        <label class="tituloLargoMobile">
                            {{ planData.soap.bus.name }}
                        </label>
                    </div>
                    <hr class="tagSpaceMobile">
                    <div class="priceMobile">
                        <label>
                            {{ formatPrice(planData.soap.bus.price) }}
                        </label>
                    </div>
                </div>
            </div>
        </div>
        <div class="quoteContainer">
            <v-btn :class="btnQuote" @click="goQuote">Cotizar y contratar</v-btn>
        </div>


        <div v-if="screen > 767" class="coveragesExclusionsTitle" @click="showCE">
            <label style="margin-left: 4%;margin-right: -16%; padding-top: 2%;padding-bottom: 2%;">Ver coberturas y exclusiones</label>
            <v-img v-if="showCoverageExclusions == false" contain :src="DownArrow" max-width="30" class="images" />
            <v-img v-else contain :src="UpArrow" max-width="30" class="images" />
        </div>

        <div v-else class="coveragesExclusionsTitleMobile" @click="showCE">
            <label style="margin-right: -3%; padding-top: 2%;padding-bottom: 2%;">Ver coberturas y exclusiones</label>
            <v-img v-if="showCoverageExclusions == false" contain :src="DownArrow" max-width="30"
                class="iconCoverage" />
            <v-img v-else contain :src="UpArrow" max-width="30" class="iconCoverage" />
        </div>

        <div v-if="showCoverageExclusions == true && screen > 767" class="coveragesExclusionsContainer">
            <div class="coverages">
                <div class="coveragesExclusionsLabel">
                    <label style="color: #000000;">¿Qué cubre?</label>
                </div>
                <div class="coveragesList">
                    <ul>
                        <li>Fallecimiento por causa de accidente.</li>
                        <li>Lesiones por causa de accidente.</li>
                        <li>Invalidez total o parcial.</li>
                        <li>Fallecimiento por ahogamiento o asfixia.</li>
                    </ul>
                </div>
            </div>
            <div class="exclusions">
                <div class="coveragesExclusionsLabel">
                    <label style="color: rgba(195,48,37, 1);">¿Qué no cubre?</label>
                </div>
                <div class="exclusionsList">
                    <ul>
                        <li>Muerte por participación en acto terrorista o guerra.</li>
                        <li>Muerte por participación en peleas o riñas, que no sean de legítima defensa.</li>
                        <li>Fallecimiento por suicidio o auto mutilación.</li>
                        <li>Desempeño de deporte de alto rendimiento.</li>
                        <li>Ataques cardíacos o parálisis a causa de estado de embriaguez o bajo efectos de drogas
                            ilícitas.</li>
                    </ul>
                </div>
            </div>
        </div>

        <div v-if="showCoverageExclusions == true && screen <= 767" class="coveragesExclusionsContainerMobile">
            <div class="coveragesMobile">
                <div class="coveragesExclusionsLabel">
                    <label style="color: #000000;">¿Qué cubre?</label>
                </div>
                <div class="coveragesListMobile">
                    <ul>
                        <li>Fallecimiento por causa de accidente.</li>
                        <li>Lesiones por causa de accidente.</li>
                        <li>Invalidez total o parcial.</li>
                        <li>Fallecimiento por ahogamiento o asfixia.</li>
                    </ul>
                    <br>
                </div>
            </div>
            <div class="exclusionsMobile">
                <div class="coveragesExclusionsLabel">
                    <label style="color: rgba(195,48,37, 1);">¿Qué no cubre?</label>
                </div>
                <div class="exclusionsListMobile">
                    <ul>
                        <li>Muerte por participación en acto terrorista o guerra.</li>
                        <li>Muerte por participación en peleas o riñas, que no sean de legítima defensa.</li>
                        <li>Fallecimiento por suicidio o auto mutilación.</li>
                        <li>Desempeño de deporte de alto rendimiento.</li>
                        <li>Ataques cardíacos o parálisis a causa de estado de embriaguez o bajo efectos de drogas
                            ilícitas.</li>
                    </ul>
                    <br>
                </div>
            </div>
        </div>


        <div v-if="screen > 767">

        </div>

        <br>
        <br v-if="screen > 767">
        <br v-if="screen > 767">


        <!-- <div v-if="screen > 767" class="quoteContainer">
            <v-btn class="btnHelp" @click="goCarePortal">Solicita cualquiera de estas ayudas gratis en <b
                    style="margin-left: 1%;">PortalCare</b><v-icon right size="25">mdi-chevron-right</v-icon> </v-btn>
        </div> -->
        <!-- <div v-else class="quoteContainer">
            <v-btn class="btnHelpMobile" @click="goCarePortal">
                <span class="btn-text">
                    Solicita cualquiera de estas <br> ayudas gratis en <strong>PortalCare</strong>
                </span>
                <v-icon class="btn-icon" style="margin-left: 5%;" size="35">mdi-chevron-right</v-icon>
            </v-btn>
        </div> -->

        <div v-if="screen > 767">
            <div class="priceTagTitle">
                <label>Si ya compraste tu SOAP con nosotros y necesitas ayuda</label>
            </div>

            <div class="subtitle">
                <label>Visita nuestro portal de ayuda para clientes SOAP</label>
            </div>

            <div class="quoteContainer">
                <v-btn   v-btn :class="btnGotoPortal" @click="goHelpPortal">IR AL PORTAL DE AYUDA</v-btn>
            </div>
        </div>
        <div v-else>
            <div class="titleMobile">
                <label>Si ya compraste tu SOAP con nosotros y necesitas ayuda</label>
            </div>

            <div class="subtitleMobile">
                <label>Visita nuestro portal de ayuda para clientes SOAP</label>
            </div>
            <div class="quoteContainer">
                <v-btn   v-btn :class="btnGotoPortalmobile" @click="goHelpPortal">IR AL PORTAL DE AYUDA</v-btn>
            </div>
        </div>
        



        <div v-if="screen > 767" class="priceTagTitle" style="margin-top: 8% !important;">
            <label>¿Por qué es importante tener un Seguro Obligatorio de Accidentes Personales (SOAP)?</label>
        </div>
        <div v-else class="priceTagTitle" style="margin-top: 20% !important;font-size: 20px;width: 75%;">
            <label>¿Por qué es importante tener un Seguro Obligatorio de Accidentes Personales (SOAP)?</label>
        </div>


        <div v-if="screen > 767">
            <div class="accordion-container">
                <div v-for="(item, index) in items" :key="index" class="accordion-item">
                    <div class="accordion-header" @click="toggle(index)">
                        <div :class="iconcontainer">
                            <img :src="item.icon" alt="icono" class="icon" />
                        </div>
                        <div :class="`accordionTitle${index + 1}`">
                            <span>{{ item.title }}</span>
                        </div>
                        <div class="arrow" :class="{ open: openIndices.includes(index) }">
                            <v-icon class="ml-2"
                                style="color: rgba(45, 85, 112, 1) !important;">mdi-chevron-down</v-icon>
                        </div>
                    </div>
                    <div v-show="openIndices.includes(index)" :class="accordionCcontent">
                        <p>{{ item.content }}</p>
                    </div>
                </div>
            </div>

            <div class="accordion-container" style="margin-top: 3%;margin-bottom: 4%;">
                <div v-for="(item, index) in items2" :key="index" class="accordion-item">
                    <div class="accordion-header" @click="toggle2(index)">
                        <div :class="iconcontainer">
                            <img :src="item.icon" alt="icono" class="icon" />
                        </div>
                        <div :class="`accordionTitle${index + 3}`">
                            <span>{{ item.title }}</span>
                        </div>


                        <div class="arrow" :class="{ open: openIndices2.includes(index) }">
                            <v-icon class="ml-2"
                                style="color: rgba(45, 85, 112, 1) !important;">mdi-chevron-down</v-icon>
                        </div>
                    </div>
                    <div v-show="openIndices2.includes(index)" :class="accordionCcontent">
                        <p>{{ item.content }}</p>
                    </div>
                </div>
            </div>
        </div>

        <div v-else>
            <div class="accordion-container-mobile">
                <div v-for="(item, index) in items" :key="index" class="accordion-item-mobile">
                    <div class="accordion-header" @click="toggle(index)">
                        <div class="icon-container-mobile">
                            <img v-if="item.icon == IconCrash" :src="item.icon" alt="icono" class="iconMobileCrash" />
                            <img v-else :src="item.icon" alt="icono" class="iconMobileMotorbike" />
                        </div>
                        <div :class="`accordionTitle${index + 1}Mobile`">
                            <span>{{ item.title }}</span>
                        </div>

                        <div class="arrow" :class="{ open: openIndices.includes(index) }">
                            <v-icon class="ml-2"
                                style="color: rgba(45, 85, 112, 1) !important;">mdi-chevron-down</v-icon>
                        </div>
                    </div>
                    <div v-show="openIndices.includes(index)" :class="accordionCcontent">
                        <p>{{ item.content }}</p>
                    </div>
                </div>
            </div>

            <div class="accordion-container-mobile" style="margin-top: 1%;margin-bottom: 4%;">
                <div v-for="(item, index) in items2" :key="index" class="accordion-item-mobile">
                    <div class="accordion-header" @click="toggle2(index)">
                        <div class="icon-container-mobile">
                            <img v-if="item.icon == IconShield" :src="item.icon" alt="icono" class="iconMobileShield" />
                            <img v-else :src="item.icon" alt="icono" class="iconMobileFile" />
                        </div>
                        <div :class="`accordionTitle${index + 3}Mobile`">
                            <span>{{ item.title }}</span>
                        </div>
                        <div class="arrow" :class="{ open: openIndices2.includes(index) }">
                            <v-icon class="ml-2"
                                style="color: rgba(45, 85, 112, 1) !important;">mdi-chevron-down</v-icon>
                        </div>
                    </div>
                    <div v-show="openIndices2.includes(index)" :class="accordionCcontent">
                        <p>{{ item.content }}</p>
                    </div>
                </div>
            </div>
        </div>


        <div :class="reprint">
            <div>
                <v-img v-if="screen > 767" contain :src="CarImage" max-width="300" style="border-top-left-radius: 10px; border-bottom-left-radius: 10px;" />
                <v-img v-else contain :src="CarImageMobile" max-width="400" />
            </div>
            <div style="margin: auto;margin-top: 2%;">
                <div v-if="screen > 767" class="priceTagTitle">
                    <label>¿Necesitas re-imprimir tu póliza de SOAP 2025?</label>
                </div>
                <div v-else class="reprintTextMobile">
                    <label>¿Necesitas re-imprimir tu póliza de SOAP 2025?</label>
                </div>

                <div v-if="screen > 767" class="quoteContainer" style="margin-top: -5%;">
                    <v-btn class="btnQuote" @click="goReprint">Re-imprime tu SOAP</v-btn>
                </div>
                <div v-else class="reprintBtnMobile" style="margin-top: -5%;margin-bottom: 4%;">
                    <v-btn class="btnQuote" @click="goReprint">Re-imprime tu SOAP</v-btn>
                </div>

            </div>
        </div>
        <br>

        <div :class="disclaimerText">
            <br>
                <label >La compañía que cubre el riesgo es Southbridge Compañía de Seguros Generales S.A. El detalle de las condiciones y exclusiones están contenidas en la póliza incorporada al depósito de pólizas de la Comisión para el Mercado Financiero (www.cmfchile.cl) bajo el código POL 3 2013 0487.
            </label>
        </div>

        <div class="footer">
            <div class="logos">
                <v-img contain :src="SouthbridgeLogo" max-width="190" />
                <v-img contain :src="CertificateLogo" max-width="40" />
            </div>
            <div :class="footerTitle">
                <label>Más de 40 años en la industria del seguro, ofreciendo productos para empresas y personas</label>
            </div>
        </div>
    </div>

</template>
<script>
// import { VueRecaptcha } from 'vue-recaptcha';
// import LogoCare from "@/assets/images/Landing/LogoCare.png";
import Care1 from "@/assets/images/Landing/Care1.png";
import Care2 from "@/assets/images/Landing/Care2.png";
import Care3 from "@/assets/images/Landing/Care3.png";
import Care1Mobile from "@/assets/images/Landing/Care1Mobile.png";
import Care2Mobile from "@/assets/images/Landing/Care2Mobile.png";
import Care3Mobile from "@/assets/images/Landing/Care3Mobile.png";
import Image1 from "@/assets/images/Landing/image1.svg";
import Image1Mobile from "@/assets/images/Landing/image1Mobile.svg";
import DownArrow from "@/assets/images/Landing/DownArrow.png";
import UpArrow from "@/assets/images/Landing/UpArrow.png";
import IconCancel from "@/assets/images/Landing/IconCancel.png";
import IconCheck from "@/assets/images/Landing/IconCheck.png";
import IconCrash from "@/assets/images/Landing/IconCrash.png";
import IconFile from "@/assets/images/Landing/IconFile.png";
import IconMoto from "@/assets/images/Landing/IconMoto.png";
import IconShield from "@/assets/images/Landing/IconShield.png";
import CarImage from "@/assets/images/Landing/CarImage.png";
import CarImageMobile from "@/assets/images/Landing/ReprintMobile.png";
import CertificateLogo from "@/assets/images/Landing/CertificateLogo.png";
import SouthbridgeLogo from "@/assets/images/Landing/SouthbridgeLogo.png";

import Auto from "@/assets/images/NewCarIcon.svg";
import Camioneta from "@/assets/images/NewVanIcon.svg";
import Carro from "@/assets/images/NewDragCartIcon.svg";
import Minibus from "@/assets/images/NewMiniBusIcon.svg";
import Moto from "@/assets/images/NewMotoIcon.svg";

import ShieldService from "../services/shield.service";
// import swal from 'sweetalert';
// import CryptoJS from 'crypto-js';

export default {
    name: "InitForm",
    components: {
        // VueRecaptcha,
    },
    data: () => ({
        secretKey: process.env.VUE_APP_CRYPT,
        openIndices: [],
        openIndices2: [],
        openCareData: [],
        // LogoCare,
        Image1,
        Image1Mobile,
        Auto,
        Camioneta,
        Carro,
        Minibus,
        Moto,
        DownArrow,
        UpArrow,
        CertificateLogo,
        SouthbridgeLogo,
        IconCancel,
        IconCheck,
        IconCrash,
        IconFile,
        IconMoto,
        IconShield,
        footerTitle: null,
        accordionCcontent: null,
        accordionTitle1: null,
        accordionTitle2: null,
        accordionTitle3: null,
        accordionTitle4: null,
        imagesAuto: null,
        btnQuote: null,
        disclaimerText: null,
        Care1,
        Care2,
        Care3,
        Care1Mobile,
        Care2Mobile,
        Care3Mobile,
        CarImage,
        CarImageMobile,
        captcha: null,
        reprint: null,
        tituloAuto: null,
        imagesCamioneta: null,
        priceTagContainerAuto: null,
        priceTagContainerMoto: null,
        showCareData1: false,
        showCareData2: false,
        showCareData3: false,
        showSoapData1: false,
        showSoapData2: false,
        showSoapData3: false,
        showSoapData4: false,
        showCoverageExclusions: false,
        priceTagTitle: null,
        planData: {},
        cliente:null,
        careContainerClass: 'careContainer',
        careContainerClassMobile: 'careContainerMobile',
        btnShowCareDetailMobile1: 'btnShowCareDetailMobile',
        btnShowCareDetailMobile2: 'btnShowCareDetailMobile',
        btnShowCareDetailMobile3: 'btnShowCareDetailMobile',
        screen: window.screen.width,
        formatter: new Intl.NumberFormat("es-CL", {
            style: "currency",
            currency: "CLP",
        }),
        items: [
            {
                title: "Seguro obligatorio por ley",
                content: "En Chile, el seguro SOAP es obligatorio por ley para todos los propietarios de vehículos motorizados. No tenerlo puede resultar en sanciones legales y multas considerables.",
                icon: IconCrash
            },
            {
                title: "Gastos médicos en caso de accidente de tránsito",
                content: "El SOAP brinda cobertura para gastos médicos en caso de accidentes de tránsito, asegurando que tanto el conductor como los pasajeros reciban atención médica adecuada.",
                icon: IconMoto
            }
        ],
        items2: [
            {
                title: "Indemnización víctimas y beneficiarios",
                content: "El seguro SOAP proporciona una indemnización a las víctimas o a sus beneficiarios, ofreciendo una protección financiera en momentos críticos, como fallecimiento o invalidez permanente. ",
                icon: IconShield
            },
            {
                title: "Requisito para renovar permiso de circulación",
                content: "El seguro SOAP es un requisito indispensable para obtener o renovar el permiso de circulación de un vehículo. Sin contar con esto, las autoridades no permiten la emisión del permiso de circulación.",
                icon: IconFile
            }
        ],
    }),
    computed: {
        containerClass() {
            return this.showCareData1 || this.showCareData2 || this.showCareData3
                ? "careContainerOpen"
                : "careContainer";
        }
    },
    methods: {
        toggle(index) {
            if (this.openIndices.includes(index)) {
                this.openIndices = this.openIndices.filter((i) => i !== index);
            } else {
                this.openIndices.push(index);
            }
        },
        toggle2(index) {
            if (this.openIndices2.includes(index)) {
                this.openIndices2 = this.openIndices2.filter((i) => i !== index);
            } else {
                this.openIndices2.push(index);
            }
        },
        toggleCare(index) {
            if (this.openCareData.includes(index)) {
                this.openCareData = this.openCareData.filter((i) => i !== index);
            } else {
                this.openCareData.push(index);
            }
            if (this.openCareData.length === 0) {
                this.careContainerClass = "careContainer";
                this.careContainerClassMobile = "careContainerMobile";
            } else {
                this.careContainerClass = "careContainerOpen";
                this.careContainerClassMobile = "careContainerOpenMobile";
            }
        },

        showCE() {
            if (this.showCoverageExclusions == true) {
                this.showCoverageExclusions = false
            } else {
                this.showCoverageExclusions = true
            }
        },
        async getPlans(path) {
            let shieldRes = await ShieldService.getPlans(path);
            if (shieldRes.status == 'ok') {
                this.planData = shieldRes.data[0];
            }
        },
        async goQuote() {
            // this.$router.push({ path: `/${this.servicesData.typeCliente}/inicio` });
            // window.location.href = `/${this.servicesData.typeCliente}/inicio`;
            window.location.href = `/${this.cliente}/inicio`;
        },
        async goHelpPortal() {
            // this.$router.push({ path: `/${this.servicesData.typeCliente}/inicio` });
            // window.location.href = `/${this.servicesData.typeCliente}/inicio`;
            window.location.href = `https://soapatencion.sbseguros.cl/create-ticket`;
        },
        // async goCarePortal() {
        //     // this.$router.push({ path: `/${this.servicesData.typeCliente}/inicio` });
        //     // window.location.href = `/${this.servicesData.typeCliente}/inicio`;
        //     window.location.href = `https://micare.salud5i.cl/?i=Care`;
        // },
        async goReprint() {
            // this.$router.push({ path: `/${this.servicesData.typeCliente}/inicio` });
            // window.location.href = `/${this.servicesData.typeCliente}/inicio`;
            window.location.href = `/consulta`;
        },
        formatPrice(number) {
            return this.formatter.format(number);
        },
    },
    async mounted() {

        let path;

        if (this.$route.path.includes('/no-clientes')) {
          path = 'soap-no-clientes-fraccion';
          this.cliente = 'no-clientes';
        } else if (this.$route.path.includes('/clientes')) {
          path = 'soap-clientes-fraccion';
          this.cliente = 'clientes';
        }
        const images = [
            require('@/assets/images/Landing/Care1.png'),
            require('@/assets/images/Landing/Care2.png'),
            require('@/assets/images/Landing/Care3.png'),
            require('@/assets/images/Landing/CarImage.png'),
            require('@/assets/images/Landing/ReprintMobile.png'),
        ];

        images.forEach((src) => {
            const img = new Image();
            img.src = src;
        });


        if (this.screen > 1001) {

            this.backgroundView = 'backgroundView'
            this.priceTagTitle = 'priceTagTitle'
            this.reprint = 'reprint'
            this.footerTitle = 'footerTitle'
            this.priceTagContainer = 'priceTagContainer'
            this.priceTagContainer2 = 'priceTagContainer2'
            this.priceTag = 'priceTag'
            this.tituloLargo = 'tituloLargo'
            this.priceTagsContainer = 'priceTagsContainer'
            this.logo = 'logo'
            this.bannerContainer = 'bannerContainer'
            this.description = 'description'
            this.right = 'right'
            this.left = 'left'
            this.careDescription = 'careDescription'
            this.images = 'images'
            this.images2 = 'images2'
            this.iconcontainer = 'icon-container'
            this.imagesCare = 'imagesCare'
            this.tituloAuto = 'tituloAuto'
            this.priceTagContainerAuto = 'priceTagContainerAuto'
            this.imagesCamioneta = 'imagesCamioneta'
            this.priceTagContainerMoto = 'priceTagContainerMoto'
            this.accordionCcontent = 'accordion-content'
            this.accordionTitle1 = 'accordionTitle1'
            this.accordionTitle2 = 'accordionTitle2'
            this.accordionTitle3 = 'accordionTitle3'
            this.accordionTitle4 = 'accordionTitle4'
            this.btnQuote = 'btnQuote'
            this.imagesAuto = 'imagesAuto'
            this.btnGotoPortal = 'btnGotoPortal'
            this.disclaimerText = 'disclaimerText3'

        } else if (this.screen <= 767) {

            this.backgroundView = 'backgroundView2'
            this.priceTagTitle = 'priceTagTitleMobile'
            this.reprint = 'reprintMobile'
            this.footerTitle = 'footerTitleMobile'
            this.accordionCcontent = 'accordion-contentMobile'
            this.btnQuote = 'btnQuote2'
            this.imagesAuto = 'imagesAuto2'
            this.btnGotoPortalmobile = 'btnGotoPortalmobile'
            this.disclaimerText = 'disclaimerText2'

        } else if (this.screen >= 768 && this.screen <= 1000) {
            this.backgroundView = 'backgroundView'
            this.priceTagTitle = 'priceTagTitle'
            this.reprint = 'reprint'
            this.footerTitle = 'footerTitle'
            this.priceTagContainer = 'priceTagContainerTablet'
            this.priceTagContainer2 = 'priceTagContainerTablet'
            this.priceTag = 'priceTagTablet'
            this.tituloLargo = 'tituloLargoTablet'
            this.priceTagsContainer = 'priceTagsContainerTablet'
            this.logo = 'logoTablet'
            this.bannerContainer = 'bannerContainerTablet'
            this.description = 'descriptionTablet'
            this.right = 'rightTablet'
            this.left = 'leftTablet'
            this.careDescription = 'careDescriptionTablet'
            this.images = 'imagesTablet'
            this.images2 = 'images2Tablet'
            this.iconcontainer = 'icon-containerTablet'
            this.imagesCare = 'imagesCareTablet'
            this.tituloAuto = 'tituloAutoTablet'
            this.btnQuote = 'btnQuote'
            this.imagesAuto = 'imagesAuto'
            this.disclaimerText = 'disclaimerText2'

        }

        this.getPlans(path);
    },
};
</script>
<style lang="css" scoped>

.disclaimerText{
  font-family: "Arial", sans-serif;
  font-size: 15px;
  letter-spacing: 0.3px;
  color: #000000;
  opacity: 1;
  text-align: justify;
  margin: auto;
  width: 73%;
}

.disclaimerText2{
  font-family: "Arial", sans-serif;
  font-size: 15px;
  letter-spacing: 0.3px;
  color: #000000;
  opacity: 1;
  text-align: justify;
  margin: auto;
  width: 85%;
}

.disclaimerText3{
  font-family: "Arial", sans-serif;
  font-size: 15px;
  letter-spacing: 0.3px;
  color: #000000;
  opacity: 1;
  text-align: justify;
  margin: auto;
  width: 53%;
}

.btnShowCareDetail {
    margin-top: 1% !important;
    background: none !important;
    border: none !important;
    text-transform: none !important;
    box-shadow: none !important;
    color: rgba(45, 85, 112, 1);
    font-weight: bold;
    margin: auto;
    display: flex;
    justify-content: center;
    font-size: 20px;
    letter-spacing: 0.4px !important;
}

.btnShowCareDetailMobile {
    margin-top: 2% !important;
    background: none !important;
    border: none !important;
    text-transform: none !important;
    box-shadow: none !important;
    color: rgba(45, 85, 112, 1);
    font-weight: bold;
    margin: auto;
    display: flex;
    justify-content: center;
    font-size: 18px;
    letter-spacing: 0.4px !important;
    margin-bottom: 3% !important;
}

.btnShowCareDetailMobileOpen {
    margin-top: 2% !important;
    background: none !important;
    border: none !important;
    text-transform: none !important;
    box-shadow: none !important;
    color: rgba(45, 85, 112, 1);
    font-weight: bold;
    margin: auto;
    display: flex;
    justify-content: center;
    font-size: 18px;
    letter-spacing: 0.4px !important;
    margin-bottom: -1% !important;
}

.bannerContainer {
    /* display: flex; */
    width: 85%;
    margin: auto;
    margin-top: 3%;
}

.bannerContainerTablet {
    display: inline;
    margin-top: 4%;
}

.logo {
    max-width: 40%;
}

.logoTablet {
    max-width: 40%;
    margin: auto;
}

.logoMobile {
    max-width: 65%;
}


.image1 {
    border-radius: 10px;
    width: 100%;
    /* max-width: 760px; */
    height: auto;
    object-fit: contain;
    margin: auto;
}

.btnQuote {
    background: #FFE428 0% 0% no-repeat padding-box !important;
    color: #000000;
    text-transform: none;
    font-family: 'Arial', sans-serif;
    font-weight: bold;
}

.btnGotoPortal {
    background: #000000 0% 0% no-repeat padding-box !important;
    color: #FFFFFF;
    text-transform: none;
    font-family: 'Arial', sans-serif;
    font-weight: bold;
}

.btnGotoPortalmobile {
    background: #000000 0% 0% no-repeat padding-box !important;
    color: #FFFFFF;
    text-transform: none;
    font-family: 'Arial', sans-serif;
    font-weight: bold;
}

.btnQuote2 {
    background: #FFE428 0% 0% no-repeat padding-box !important;
    color: #000000;
    text-transform: none;
    font-family: 'Arial', sans-serif;
    font-weight: bold;
    width: 65%;
}

.priceTagsContainer {
    display: flex;
    gap: 3%;
    justify-content: center;
    margin-top: -3% !important;
    width: 84%;
    align-items: center;
    margin: auto;
}

.priceTagsContainerTablet {
    display: flex;
    gap: 1%;
    justify-content: center;
    margin-top: -3%;
}

.priceTagsContainerMobile {
    margin-bottom: 14% !important;
}

.priceTagTitle {
    font-family: 'Arial', sans-serif;
    color: rgba(0, 0, 0, 1);
    font-weight: bold;
    font-size: 24px;
    margin: auto;
    text-align: center;
    margin-top: 4%;
    margin-bottom: 8%;
}

.reprintTextMobile {
    font-family: 'Arial', sans-serif;
    color: #000000;
    font-weight: bold;
    font-size: 22px;
    margin: auto;
    text-align: center;
    margin-top: 3%;
    margin-bottom: 8%;
    width: 87%;
}

.titleMobile {
    font-family: 'Arial', sans-serif;
    color: #000000;
    font-weight: bold;
    font-size: 20px;
    margin: auto;
    text-align: center;
    margin-top: 3%;
    margin-bottom: 8%;
    width: 84%;
}

.priceTagTitleMobile {
    font-family: 'Arial', sans-serif;
    color: rgba(0, 0, 0, 1);
    font-weight: bold;
    font-size: 20px;
    margin: auto;
    text-align: center;
    margin-top: 8%;
    margin-bottom: 8%;
    width: 61%;
}

.priceTagTitleMobile2 {
    font-family: 'Arial', sans-serif;
    color: rgba(0, 0, 0, 1);
    font-weight: bold;
    font-size: 22px;
    margin: auto;
    text-align: center;
    margin-top: 14%;
    margin-bottom: 14% !important;
    width: 100%;
    background-color: red !important;
}

.priceTag {
    /* display: flex; */
    background-color: rgba(246, 246, 246, 1);
    border-radius: 6px;
    height: 150px;
    width: 17%;
}

.priceTagTablet {
    /* display: flex; */
    background-color: rgba(246, 246, 246, 1);
    border-radius: 6px;
    height: 167px;
    width: 20%;
}

.priceTagMobile {
    /* display: flex; */
    background-color: rgba(246, 246, 246, 1);
    border-radius: 6px;
    height: 110px;
    width: 45%;
}

.priceTagContainer {
    height: 62px;
    display: flex;
    place-items: flex-start;
    padding-top: 9%;
    margin-left: 3%;
    margin-bottom: 18%;
}

.priceTagContainerBus {
    height: 62px;
    display: flex;
    place-items: flex-start;
    padding-top: 15%;
    margin-left: 8%;
    margin-bottom: 18%;
}

.priceTagContainerMoto {
    height: 62px;
    display: flex;
    place-items: flex-start;
    padding-top: 17%;
    margin-left: 8%;
    margin-bottom: 18%;
}

.priceTagContainerAuto {
    height: 62px;
    display: flex;
    place-items: flex-start;
    padding-top: 10%;
    margin-left: 3%;
    margin-bottom: 19%;
    width: 100%;
}

.priceTagContainer2 {
    height: 62px;
    display: flex;
    place-items: flex-start;
    padding-top: 6%;
    margin-left: 26%;
}

.priceTagContainerTablet {
    height: 100px;
    margin: auto;
    width: 80%;
    text-align: center;
}

.images {
    margin-left: 6%;
}

.imagesAuto {
    margin-left: 6%;
    margin-top: 5%;
}
.imagesAuto2 {
}

.imagesBus {
    margin-left: 6%;
    margin-top: 5%;
}

.imagesCarro {
    margin-left: 6%;
    margin-top: 7%;
}

.imagesCamioneta {
    margin-left: 6%;
    margin-top: 6%;
}

.imagesTablet {
    margin: auto;
    margin-top: 5%;
}

.images2 {
    margin-left: 26%;
}

.images2Tablet {
    margin: auto;
    margin-top: 5%;
}

.imagesCare {
    max-width: 300px;
    margin: auto;
}

.imagesCareTablet {
    max-width: 200px;
    margin: auto;
}

.tituloLargo {
    text-align: left;
    font: Arial;
    font-size: 14px;
    font-weight: 600;
    letter-spacing: 0.23px;
    color: rgba(0, 0, 0, 1);
    opacity: 1;
    margin-top: -1%;
    margin-left: 8%;
    width: 72%;
    height: 49px;
}

.tituloLargoBus {
    text-align: left;
    font: Arial;
    font-size: 14px;
    font-weight: 600;
    letter-spacing: 0.23px;
    color: rgba(0, 0, 0, 1);
    opacity: 1;
    margin-left: 8%;
    width: 72%;
    height: 49px;
}

.tituloLargoMoto {
    text-align: left;
    font: Arial;
    font-size: 14px;
    font-weight: 600;
    letter-spacing: 0.23px;
    color: rgba(0, 0, 0, 1);
    opacity: 1;
    margin-top: 2%;
    margin-left: 8%;
    width: 72%;
    height: 49px;
}

.tituloAuto {
    text-align: left;
    font: Arial;
    font-size: 14px;
    font-weight: 600;
    letter-spacing: 0.23px;
    color: #000000;
    opacity: 1;
    margin-left: 8%;
    width: 59%;
    height: 49px;
}

.tituloLargoTablet {
    text-align: left;
    font: Arial;
    font-size: 16px;
    font-weight: 600;
    letter-spacing: 0.23px;
    color: #000000;
    opacity: 1;
    /* margin-top: 2%; */
    /* margin-left: 8%; */
    margin: auto;
    width: 87%;
    height: 49px;
}

.tituloLargoMobile {
    text-align: left;
    font: Arial;
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 0.23px;
    color: #000000;
    opacity: 1;
    /* margin-top: 2%; */
    margin-left: 8%;
    width: 52%;
}

.tituloCamionetaMobile {
    text-align: left;
    font: Arial;
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 0.23px;
    color: #000000;
    opacity: 1;
    /* margin-top: 2%; */
    margin-left: 8%;
    width: 52%;
}

.tagSpace {
    width: 80%;
    margin: auto;
    margin-top: 2%;
    margin-bottom: 2%;
    border: none;
    background-color: rgba(45, 85, 112, 1);
    height: 1px;
}

.tagSpaceMobile {
    width: 78%;
    margin: auto;
    margin-top: 2%;
    margin-bottom: 2%;
    border: none;
    background-color: rgba(45, 85, 112, 1);
    height: 1px;
}

.price {
    text-align: center;
    font: Arial;
    font-size: 30px;
    letter-spacing: 0.96px;
    color: rgba(0, 0, 0, 1);
    height: 43px;
}

.priceMobile {
    text-align: center;
    font: Arial;
    font-size: 26px;
    letter-spacing: 0.96px;
    color: rgba(0, 0, 0, 1);
}

.coveragesExclusionsTitle {
    cursor: pointer;
    background-color: rgba(246, 246, 246, 1);
    margin-top: 4% !important;
    width: 35%;
    margin: auto;
    text-align: center;
    font-family: 'Arial', sans-serif;
    color: rgba(0, 0, 0, 1);
    font-weight: bold;
    font-size: 24px;
    border-radius: 6px;
    border-bottom: 6px solid rgba(0, 0, 0, 1);
    display: flex;
    justify-content: center;
    gap: 14%;
}

.coveragesExclusionsTitleMobile {
    cursor: pointer;
    background-color: rgba(246, 246, 246, 1);
    margin-top: 10% !important;
    width: 90%;
    margin: auto;
    text-align: center;
    font-family: 'Arial', sans-serif;
    color: rgba(0, 0, 0, 1);
    font-weight: bold;
    font-size: 20px;
    border-radius: 6px;
    border-bottom: 6px solid rgba(0, 0, 0, 1);
    display: flex;
    justify-content: center;
    gap: 6%;
}

.leftTablet {
    text-align: center;
    margin-left: 2%;
    margin-right: 2%;
    margin-bottom: 3%;
}

.coveragesExclusionsContainer {
    display: flex;
    gap: 6%;
    width: 95%;
    justify-content: center;
    margin-top: 4% !important;
    margin: auto;
}

.coveragesExclusionsContainerMobile {
    width: 95%;
    margin-top: 4% !important;
    margin: auto;
}

.coverages {
    background-color: rgba(246, 246, 246, 1);
    width: 36%;
    border-top: 4px solid rgba(45, 85, 112, 1);
}

.coveragesMobile {
    margin-top: 10% !important;
    background-color: rgba(246, 246, 246, 1);
    width: 94%;
    border-top: 4px solid rgba(45, 85, 112, 1);
    margin: auto;
}

.exclusions {
    background-color: rgba(246, 246, 246, 1);
    width: 36%;
    border-top: 4px solid rgba(195, 48, 37, 1);
}

.exclusionsMobile {
    margin-top: 10% !important;
    background-color: rgba(246, 246, 246, 1);
    width: 94%;
    border-top: 4px solid rgba(195, 48, 37, 1);
    margin: auto;
}

.coveragesExclusionsLabel {
    text-align: center;
    font-family: 'Arial', sans-serif;
    font-weight: bold;
    font-size: 24px;
    margin-top: 3%;
}

.coveragesList {
    margin: auto;
    margin-top: 3%;
    margin-left: 5%;
}

.coveragesList ul {
    list-style: none;
    padding: 0;
}

.coveragesList li {
    background: url("~@/assets/images/Landing/IconCheck.png") no-repeat left center;
    background-size: 20px 20px;
    padding-left: 30px;
    /* Ajusta el espacio según el tamaño del ícono */
    margin-bottom: 10px;
}

.coveragesListMobile {
    margin: auto;
    margin-top: 3%;
    margin-left: 4%;
}

.coveragesListMobile ul {
    list-style: none;
    padding: 0;
}

.coveragesListMobile li {
    background: url("~@/assets/images/Landing/IconCheck.png") no-repeat left center;
    background-size: 20px 20px;
    padding-left: 30px;
    /* Ajusta el espacio según el tamaño del ícono */
    margin-bottom: 10px;
}

.rightTablet {
    width: 80%;
    margin: auto;
}

.descriptionTablet {
    margin: auto;
}

.exclusionsList {
    margin: auto;
    margin-top: 3%;
    margin-left: 4%;
    padding-bottom: 2%;
}

.exclusionsList ul {
    list-style: none;
    padding: 0;
}

.exclusionsList li {
    background: url("~@/assets/images/Landing/IconCancel.png") no-repeat left center;
    background-size: 20px 20px;
    padding-left: 30px;
    /* Ajusta el espacio según el tamaño del ícono */
    margin-bottom: 10px;
}

.exclusionsListMobile {
    margin: auto;
    margin-top: 3%;
    margin-left: 4%;
    padding-right: 1%;
}

.exclusionsListMobile ul {
    list-style: none;
    padding: 0;
}

.exclusionsListMobile li {
    background: url("~@/assets/images/Landing/IconCancel.png") no-repeat left center;
    background-size: 20px 20px;
    padding-left: 30px;
    /* Ajusta el espacio según el tamaño del ícono */
    margin-bottom: 10px;
}

.quoteContainer {
    display: flex;
    justify-content: center;
    margin-top: 4%;
}

.reprintBtnMobile {
    display: flex;
    justify-content: center;
    margin-top: 4%;
}

.careBlock {
    display: grid;
    grid-template-rows: auto auto 0.3fr;
    transition: grid-template-rows 0.3s ease-out;
    justify-items: center;
    width: 100%;
    gap: 10px;
    align-items: baseline;
}

.careContainer {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 78%;
    margin: auto;
    margin-bottom: -7% !important;
}

.careContainerOpen {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 78%;
    margin: auto;
    margin-bottom: 14% !important;
}

.careContainerMobile {
    width: 93%;
    margin: auto;
}

.careContainerOpenMobile {
    width: 93%;
    margin: auto;
    margin-bottom: 24% !important;
}

.careDescription {
    color: rgba(85, 85, 85, 1);
    font-family: 'Arial', sans-serif;
    width: 68%;
    font-size: 20px;
    line-height: 35px;
    padding: 10px;
    overflow: hidden;
    height: 0;
    opacity: 0;
    margin-top: 30% !important;
    /* margin-bottom: 10%; */
    transition: height 0.3s ease-out, opacity 0.3s ease-out;
    line-height: 1.6 !important;
}

.careDescriptionTablet {
    color: rgba(85, 85, 85, 1);
    font-family: 'Arial', sans-serif;
    width: 88%;
    font-size: 15px;
    padding: 8px;
    overflow: hidden;
    height: 0;
    opacity: 0;
    margin-top: 39%;
    transition: height 0.3s ease-out, opacity 0.3s ease-out;
    line-height: 1.6 !important;

}

/* Mostrar descripción cuando está activa */
.careBlock.open {
    grid-template-rows: auto auto 1fr;
    /* La descripción crece */
}

.careDescription.show {
    height: auto;
    opacity: 1;
    margin-top: -2% !important;
    margin-bottom: 41% !important;
}

.careDescriptionTablet.show {
    height: auto;
    opacity: 1;
}

.careDescriptionMobile {
    color: rgba(85, 85, 85, 1);
    font-family: 'Arial', sans-serif;
    width: 95%;
    font-size: 18px;
    margin-left: 3% !important;
    line-height: 26px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 8%;
    margin-top: 2%;
}

.subtitle {
    font-family: 'Arial', sans-serif;
    color: rgba(40, 40, 40, 1);
    font-weight: bold;
    font-size: 20px;
    margin: auto;
    text-align: center;
    margin-top: -5% !important;
    margin-bottom: -1% !important;
}

.subtitleMobile {
    font-family: 'Arial', sans-serif;
    color: rgba(40, 40, 40, 1);
    font-weight: bold;
    font-size: 16px;
    margin: auto;
    text-align: center;
    margin-top: 0% !important;
    width: 76%;
    margin-bottom: 6% !important;

}

.cardsContainer {
    /* display: flex; */
    width: 100%;
    margin: auto;
    min-width: 95%;
    /* min-height: 200px; */
    transition: min-height 0.3s ease-in-out;
    display: block;
    align-items: center;
    justify-content: center;
    background-color: yellowgreen;
}

.cardsIcon {
    /* margin-left: 40% !important;  */
    z-index: 9999;
    color: rgba(45, 85, 112, 1);
}

.cartTitlelabel {
    margin-left: 11%;
    margin-right: 7%;
}

.cartTitle {
    cursor: pointer;
    background-color: rgba(248, 248, 248, 1);
    margin: auto;
    width: 44%;
    color: rgba(45, 85, 112, 1);
    font-weight: 500;
    height: 50px;
    font-size: 20px;
    display: flex;
    align-items: center;
    /* padding: 0 15px;  */
    border-radius: 25px;
}

.icon {
    z-index: 1;
    position: absolute;
}

.cardDescription {
    background-color: rgba(248, 248, 248, 1);
    width: 45%;
    margin: auto;
    padding-top: 2%;
    padding-left: 2%;
    /* padding-right: 4%; */
    border-radius: 8px;
    height: 110px;
    transition: height 0.3s ease-in-out;
    margin-top: 2%;

}

.reprint {
    display: flex;
    border-radius: 8px;
    border-right: 8px solid #FFE428;
    width: 80%;
    margin: auto;
    background-color: rgba(248, 248, 248, 1);
    box-shadow: 0px 6px 6px #00000029;
}

.reprintMobile {
    border-radius: 8px;
    width: 90%;
    margin: auto;
    background-color: rgba(248, 248, 248, 1);
    box-shadow: 0px 6px 6px #00000029;
    height: 330px;
}

.footer {
    margin-top: 4%;
    background-color: rgba(250, 250, 250, 1);
    margin-bottom: -5%;
}

.logos {
    display: flex;
    gap: 6%;
    justify-content: center;
    padding-top: 2%;
}

.footerTitle {
    margin: auto;
    text-align: center;
    margin-top: 1%;
    color: rgba(85, 85, 85, 1);
    font-family: 'Arial', sans-serif;
    padding-bottom: 3%;
}

.footerTitleMobile {
    margin: auto;
    text-align: center;
    margin-top: 8%;
    color: rgba(85, 85, 85, 1);
    font-family: 'Arial', sans-serif;
    width: 90%;
}

/* accordions */
.accordion-container {
    width: 73%;
    margin: auto;
    /* background-color: yellow; */
    display: flex;
    justify-content: center;
    gap: 5%;
}

.accordion-container-mobile {
    width: 95%;
    margin: auto;
    /* background-color: yellow; */
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-left: 4.5%;
}

.accordion-item {
    margin-bottom: 10px;
    border-radius: 10px;
    overflow: hidden;
    color: #000000;
    /* box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1); */
    width: 95%;
}

.accordion-item-mobile {
    margin-bottom: 8% !important;
    border-radius: 10px;
    overflow: hidden;
    color: #000000;
    /* box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1); */
    width: 95%;
}

.accordion-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px;
    cursor: pointer;
    font-weight: bold;
    background: rgba(248, 248, 248, 1);
    border-radius: 24px;
    height: 56px !important;
}

.icon-container {
    width: 30px;
    height: 30px;
    margin-right: 1%;
    margin-left: -3%;
    margin-top: -7%;
}

.icon-containerTablet {
    width: 30px;
    height: 30px;
    margin-right: 7%;
    margin-top: -5%;
}

.icon-container-mobile {
    width: 50px;
    height: 18px;
    margin-right: 1%;
    margin-left: -3% !important;
    margin-top: -10%;
    z-index: 9999 !important;
    line-height: 0.8 !important;
}

.icon {
    width: 4.3%;
}

.iconMobileCrash {
    width: 14%;
    margin-left: -4%;
    z-index: 9999 !important;
    position: absolute;
    margin-top: -0.5%;
}

.iconMobileShield {
    width: 14%;
    margin-left: -4%;
    z-index: 9999 !important;
    position: absolute;
    margin-top: -0.5%;
}

.iconMobileFile {
    width: 14%;
    margin-left: -4%;
    z-index: 9999 !important;
    position: absolute;
    margin-top: -0.5%;
}

.iconMobileMotorbike {
    width: 14%;
    margin-left: -4%;
    z-index: 9999 !important;
    position: absolute;
    margin-top: -0.5%;
}

.arrow {
    transition: transform 0.1s;

}

.arrow.open {
    transform: rotate(180deg);
}

.accordion-content {
    margin-top: 4%;
    padding: 15px;
    border-radius: 10px;
    background: rgba(248, 248, 248, 1);
    height: 121px;
    color: rgba(51, 51, 51, 1);
}

.accordion-contentMobile {
    margin-top: 4%;
    padding: 15px;
    border-radius: 10px;
    background: rgba(248, 248, 248, 1);
    height: 145px;
    color: rgba(51, 51, 51, 1);
}

.motoContainer {
    display: flex;
    align-items: center;
    margin-bottom: 7% !important;
    justify-content: center;
    margin-top: 12% !important;
    width: 50%;
    margin: auto;
}

.accordionTitle1 {
    margin-left: -26%;
}

.accordionTitle1Mobile {
    margin-left: -26%;
}

.accordionTitle2 {
    margin-left: 7%;
}

.accordionTitle2Mobile {
    margin-left: 1%;
}

.accordionTitle3 {
    margin-left: -6%;
}

.accordionTitle3Mobile {
    margin-left: -1%;
}

.accordionTitle4 {
    margin-left: 3%;
}

.accordionTitle4Mobile {
    margin-left: 1%;
}

@media (min-width: 1440px) {
    .image1 {
        width: 100%;
        /* max-width: 800px; */
    }

    .right {
        padding: 0px;
    }

    .tituloAuto {
        text-align: left;
        font: Arial;
        font-size: 16px;
        font-weight: 600;
        letter-spacing: 0.23px;
        color: #000000;
        opacity: 1;
        margin-top: 5%;
        margin-left: 8%;
        width: 59%;
        height: 49px;
    }

    .tituloLargo {
        text-align: left;
        font: Arial;
        font-size: 16px;
        font-weight: 600;
        letter-spacing: 0.23px;
        color: #000000;
        opacity: 1;
        margin-top: -1%;
        margin-left: 6%;
        width: 72%;
        height: 49px;
    }

    .tituloLargoMoto {
        text-align: left;
        font: Arial;
        font-size: 16px;
        font-weight: 600;
        letter-spacing: 0.23px;
        color: #000000;
        opacity: 1;
        margin-top: 2%;
        margin-left: 8%;
        width: 72%;
        height: 49px;
    }

    .tituloLargoBus {
        text-align: left;
        font: Arial;
        font-size: 16px;
        font-weight: 600;
        letter-spacing: 0.23px;
        color: #000000;
        opacity: 1;
        margin-left: 8%;
        width: 72%;
        height: 49px;
        margin-top: 3%;
    }

    .priceTagContainerMoto {
        height: 62px;
        display: flex;
        place-items: flex-start;
        padding-top: 16%;
        margin-left: 8%;
        margin-bottom: 16%;
    }

    .priceTagsContainer {
        display: flex;
        gap: 2%;
        justify-content: center;
        align-items: center;
        margin-top: -3% !important;
        width: 100%;
        margin: auto;
    }

    .priceTagContainer {
        height: 62px;
        display: flex;
        place-items: flex-start;
        padding-top: 12%;
        margin-left: 5%;
        margin-bottom: 20%;
        margin-top: -3%;
    }

    .priceTag {
        background-color: rgba(246, 246, 246, 1);
        border-radius: 6px;
        height: 163px;
        width: 14%;
    }

    .priceTagContainerBus {
        height: 62px;
        display: flex;
        place-items: flex-start;
        padding-top: 11%;
        margin-left: 8%;
        margin-bottom: 16%;
    }

    .priceTagContainerAuto {
        height: 62px;
        display: flex;
        place-items: flex-start;
        padding-top: 6%;
        margin-left: 5%;
        margin-bottom: 20%;
        margin-top: -3%;
    }

    .imagesCamioneta {
        margin-left: 6%;
        margin-top: 7%;
    }

    .imagesCarro {
        margin-left: 6%;
        margin-top: 7%;
    }

    .imagesBus {
        margin-left: 6%;
        margin-top: 8%;
    }

    .footer {
        margin-top: 4%;
        background-color: rgba(250, 250, 250, 1);
        margin-bottom: -3.5%;
    }

    .careDescription {
        color: rgba(85, 85, 85, 1);
        font-family: 'Arial', sans-serif;
        width: 48%;
        font-size: 20px;
        line-height: 35px;
        padding: 10px;
        overflow: hidden;
        height: 0;
        opacity: 0;
        margin-top: 22%;
        margin-left: 1%;
        transition: height 0.3s ease-out, opacity 0.3s ease-out;
    }

    .accordionTitle1 {
        margin-left: -37%;
    }

    .accordionTitle2 {
        margin-left: -12%;
    }

    .accordionTitle3 {
        margin-left: -23%;
    }

    .accordionTitle4 {
        margin-left: -15%;
    }
    .imagesAuto {
        margin-top: 15% !important;
    }
    
    .careDescription.show {
        height: auto;
        opacity: 1;
        margin-top: -2% !important;
        line-height: 1.7 !important;
    }

}
</style>